const crmIntegrationProviderMap = {
    salesforce: "salesforce",
    hubspot: "hubspot",
    dynamics: "dynamics",
} as const;
export type CrmIntegrationProvider = (typeof crmIntegrationProviderMap)[keyof typeof crmIntegrationProviderMap];

export const CRM_INTEGRATION_PROVIDERS: readonly CrmIntegrationProvider[] = Object.values(crmIntegrationProviderMap);

const apiToProviderMap: Record<string, CrmIntegrationProvider> = {
    microsoftdynamics: "dynamics",
};

export const normalizeCrmProvider = (apiName: string): CrmIntegrationProvider =>
    apiToProviderMap[apiName] ?? (apiName as CrmIntegrationProvider);

const providerToApiPath: Record<CrmIntegrationProvider, string> = {
    salesforce: "salesforce",
    hubspot: "hubspot",
    dynamics: "microsoft-dynamics",
};

export const getApiPathForProvider = (provider: CrmIntegrationProvider): string => providerToApiPath[provider];
